import urlApi from "./urlApi";
export var GET_THEMATIC_REQUEST = 'GET_THEMATIC_REQUEST';
export var GET_THEMATIC_REQUEST_SUCCESS = 'GET_THEMATIC_REQUEST_SUCCESS';
export var GET_THEMATIC_REQUEST_ERROR = 'GET_THEMATIC_REQUEST_ERROR';
export function getThematic() {
    return function (dispatch) {
        dispatch({
            type: GET_THEMATIC_REQUEST,
        });
        urlApi().getThematics().then(function (res) {
            dispatch({
                type: GET_THEMATIC_REQUEST_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: GET_THEMATIC_REQUEST_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getThematics.js.mapimport urlApi from "./urlApi";
export var GET_THEMATIC_REQUEST = 'GET_THEMATIC_REQUEST';
export var GET_THEMATIC_REQUEST_SUCCESS = 'GET_THEMATIC_REQUEST_SUCCESS';
export var GET_THEMATIC_REQUEST_ERROR = 'GET_THEMATIC_REQUEST_ERROR';
export function getThematic() {
    return function (dispatch) {
        dispatch({
            type: GET_THEMATIC_REQUEST,
        });
        urlApi().getThematics().then(function (res) {
            dispatch({
                type: GET_THEMATIC_REQUEST_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: GET_THEMATIC_REQUEST_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getThematics.js.map